export function put(key, value) {

  if (!_isStorageSupported())
    return;
  window.localStorage.setItem(key, JSON.stringify(value));
}

export function get(key) {
  let data = window.localStorage.getItem(key);
  return data
    ? JSON.parse(data)
    : null;
}

export function remove(key) {
  window.localStorage.removeItem(key);
}

function _isStorageSupported() {
  if (typeof(Storage) !== "undefined") {
    return true;
  } else {
    console.info('local storage not supported');
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/utils/localStorageHelper.js